import { useState } from "react";
import { Loader2, Trash2 } from "lucide-react";
import { Button } from "@/components/ui/button";
import { catalogApi } from "@/lib/api/catalog";
import { useToast } from "@/contexts/ToastContext";
import { getApiErrorMessage } from "@/lib/api-error";

type CatalogDraftDeleteButtonProps = {
  id: string;
  onDeleted: () => void;
};

export function CatalogDraftDeleteButton({ id, onDeleted }: CatalogDraftDeleteButtonProps) {
  const toast = useToast();
  const [busy, setBusy] = useState(false);

  const remove = async () => {
    if (!window.confirm("Delete this draft permanently? This cannot be undone.")) return;
    setBusy(true);
    try {
      await catalogApi.deleteDraft(id);
      toast.success("Draft deleted.");
      onDeleted();
    } catch (err: unknown) {
      toast.error(getApiErrorMessage(err, "Could not delete this draft."));
    } finally {
      setBusy(false);
    }
  };

  return (
    <Button type="button" variant="destructive" size="sm" onClick={remove} disabled={busy}>
      {busy ? (
        <Loader2 className="mr-1 h-4 w-4 animate-spin" />
      ) : (
        <Trash2 className="mr-1 h-4 w-4" />
      )}
      Delete
    </Button>
  );
}
